import React, {useState } from "react";
import { Dropdown } from 'rsuite';
import $ from 'jquery';

let DropdownView = (props) =>{

    const [selectedItem, setItem] = useState(props.data.min);
  
    const handleInnerClick = (e) =>{
       // setItem(e.target);

       let v = $(e.target).html();
       setItem(v);
        props.handleClick(e,props.data.index)
    }
    var rows = [];
    for (var i=props.data.min; i<=(props.data.max-props.data.min+1); i++){
        rows.push(i);
    }
    return (       
      <>
      <Dropdown title={selectedItem}>
      {rows.map((item, index ) => 
        <Dropdown.Item key={index} onClick={handleInnerClick} style={{width:"50px", textAlign:"center"}} >{item}</Dropdown.Item>
      )}
        
      </Dropdown>
            
        </>
    )
    
    
}

export default DropdownView;